import React, { useEffect } from 'react';
import Layout from '../../../layout';
import CustomerFooter from 'components/CustomerFooter';
import { DeepLinkAgreeCompleteWrapper } from './style';
import { useUI } from 'contexts/UIContext';
import ROUTE_PATH from '../../../routes/config';
import { useNavigate } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const DeepLinkAgreeComplete = () => {
  const { setContextLoading } = useUI();
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      setContextLoading(false);
    }, 100);
  }, []);

  return (
    <Layout isShowBannerPage={false} pageTitle="main" onlyLogo={true}>
      <DeepLinkAgreeCompleteWrapper>
        <div className="wrapBox">
          <div className="titleBox">
            <p className="title">데이터 제공동의가 완료되었습니다.</p>
            <p className="subtitle">
              추가적인 세부 사항은 '대출/데이터 제공 관리 화면'에서 확인하실 수
              있습니다.
            </p>
          </div>
          <dl>
            <dt>
              <FeatherIcon icon="alert-circle" size={14} strokeWidth={2} />
              <span>판매몰 추가 안내</span>
            </dt>
            <dd>
              <span>동의 후에도 판매몰을 추가하실 수 있습니다.</span>
              <br />
              판매몰을 추가하면 대출 한도가 상향될 수 있습니다.
              <br />
              판매몰 연동 후, 고객센터로 문의해 주세요.
            </dd>
          </dl>
          <button
            type="button"
            className="btnMoreMall"
            onClick={() => navigate(ROUTE_PATH.mypage.dataLinkageManage)}
          >
            <span>다른 판매몰이 더 있으신가요?</span>
            <br />
            데이터 연동 추가 하기
          </button>
          <button
            type="button"
            className="btnDataManage"
            onClick={() => navigate(ROUTE_PATH.mypage.manageLoanDataProvide)}
          >
            대출/데이터 제공 관리 화면 가기
          </button>
        </div>
        <CustomerFooter />
      </DeepLinkAgreeCompleteWrapper>
    </Layout>
  );
};

export default DeepLinkAgreeComplete;
